import { observable, computed, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import OfferTemplate from './OfferTemplate';
import {AttachedDocument} from '../documents';
import {Employee} from '../employees';

class Offer extends DomainObject {
  firstName;
  lastName;
  fields = [];
  expiresAt;
  sentAt;
  email;
  offerTemplate;
  renderedContent;
  attachments;
  employee;
  acceptedAt;
  revokedAt;
  hiredAt;
  revokeReason;
  viewStatus;
  viewStatusUpdatedAt;
  candidateId;
  isExpired;
  isAccepted;
  isRevoked;
  lexicalState;

  _relations = {
    _dates: ['expiresAt', 'acceptedAt', 'revokedAt', 'hiredAt'],
    offerTemplate: OfferTemplate,
    attachments: [AttachedDocument],
    employee: Employee,
  };

  constructor(other) {
    super();

    makeObservable(this, {
      firstName: observable,
      lastName: observable,
      fields: observable,
      expiresAt: observable,
      sentAt: observable,
      email: observable,
      offerTemplate: observable,
      renderedContent: observable,
      attachments: observable,
      employee: observable,
      acceptedAt: observable,
      revokedAt: observable,
      hiredAt: observable,
      revokeReason: observable,
      viewStatus: observable,
      viewStatusUpdatedAt: observable,
      candidateId: observable,
      isExpired: observable,
      isAccepted: observable,
      isRevoked: observable,
      lexicalState: observable,
      name: computed
    });

    this.merge(other);
  }

  get name() {
    return `${this.firstName} ${this.lastName}`;
  }
}

export default Offer;
